exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hide[data-v-388d81ca]{display:none}", ""]);

// exports
